
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import moment from 'moment';
import { schedule10DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { disagreeExistingSpouseSupportDataInfoType, replyExistingSpouseSupportDataInfoType, rflmCalculatingSpouseSupportDataInfoType, rflmUnpaidSpouseSupportDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/SpousalSupport';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})
export default class Schedule10 extends Vue {

    @Prop({required:true})
    result!: any; 
  
    dataReady = false;    
    exSpsSupInfo = {} as schedule10DataInfoType;
   
    mounted(){
        this.dataReady = false;       
        this.extractInfo();       
        this.dataReady = true;       
    }

    public extractInfo(){        
        this.exSpsSupInfo = this.getExistingSpousalSupportInfo();
    }

    public getExistingSpousalSupportInfo(){        

        let existingSpouseSupportInfo = {} as schedule10DataInfoType; 

        if (this.result.replyExistingSpouseSupportSurvey && this.result.rflmUnpaidSpouseSupportSurvey 
                && this.result.rflmCalculatingSpouseSupportSurvey && this.result.disagreeExistingSpouseSupportSurvey 
                && this.result.flmAdditionalDocumentsSurvey){

            const replyExistingSpouseSupportInfo: replyExistingSpouseSupportDataInfoType = this.result.replyExistingSpouseSupportSurvey;
            if (replyExistingSpouseSupportInfo.existingType == 'finalOrder'){
                existingSpouseSupportInfo.agreeCircumstanceChanges = replyExistingSpouseSupportInfo.agreeFinalOrder == 'y';
                existingSpouseSupportInfo.disAgreeCircumstanceChanges = replyExistingSpouseSupportInfo.agreeFinalOrder == 'n';
                existingSpouseSupportInfo.disagreeSetAside = false;
                existingSpouseSupportInfo.agreeSetAside = false;

            } else if (replyExistingSpouseSupportInfo.existingType == 'agreement'){
                existingSpouseSupportInfo.disagreeSetAside = replyExistingSpouseSupportInfo.agreeAgreement == 'y';
                existingSpouseSupportInfo.agreeSetAside = replyExistingSpouseSupportInfo.agreeAgreement == 'n';
                existingSpouseSupportInfo.agreeCircumstanceChanges = false;
                existingSpouseSupportInfo.disAgreeCircumstanceChanges = false;
            }

            const rflmUnpaidSpouseSupportInfo: rflmUnpaidSpouseSupportDataInfoType = this.result.rflmUnpaidSpouseSupportSurvey;

            existingSpouseSupportInfo.unpaidDetails = {
                agreeAmount: rflmUnpaidSpouseSupportInfo.agreeSpouseSupportAmount == 'y',
                crntDate: rflmUnpaidSpouseSupportInfo.agreeSpouseSupportAmount == 'n'? Vue.filter('beautify-date')(rflmUnpaidSpouseSupportInfo.calculationDate):'',
                unpaidAmnt: rflmUnpaidSpouseSupportInfo.agreeSpouseSupportAmount == 'n'?rflmUnpaidSpouseSupportInfo.unPaidAmount:''

            }           
            const calculationInfo: rflmCalculatingSpouseSupportDataInfoType = this.result.rflmCalculatingSpouseSupportSurvey;
                    
            existingSpouseSupportInfo.calc = {                
                attaching: calculationInfo.attachingCalculations == 'y',
                reason: calculationInfo.attachingCalculations == 'n'?calculationInfo.notAttachingCalculationsReason:''
            } 

            const disagreeExistingSpouseSupportInfo: disagreeExistingSpouseSupportDataInfoType = this.result.disagreeExistingSpouseSupportSurvey;

            existingSpouseSupportInfo.disagreeReason = disagreeExistingSpouseSupportInfo.disagreeReason;
            existingSpouseSupportInfo.continue = disagreeExistingSpouseSupportInfo.requestedOrder == 'noChange';
            existingSpouseSupportInfo.change = disagreeExistingSpouseSupportInfo.requestedOrder == 'diffChange';
            existingSpouseSupportInfo.changeExpl = disagreeExistingSpouseSupportInfo.requestedOrder == 'diffChange'?disagreeExistingSpouseSupportInfo.requestedChangeDescription:'';  
            existingSpouseSupportInfo.filingForm4 = this.result.flmAdditionalDocumentsSurvey.isFilingAdditionalDocs == 'y'
          
        } else {

            const calculationsInfo = {
                attaching: false,
                reason: ''
            }
            const spouseSupportUnpaid = {
                agreeAmount: false,
                crntDate: '',
                unpaidAmnt: ''
            }
            existingSpouseSupportInfo = {
            
                agreeCircumstanceChanges: false,
                disAgreeCircumstanceChanges: false,
                agreeSetAside: false,
                disagreeSetAside: false,
                disagreeReason: '',
                continue: false,  
                change: false,
                changeExpl: '',     
                calc: calculationsInfo,
                unpaidDetails: spouseSupportUnpaid,
                filingForm4: false
            }    
        }

        return existingSpouseSupportInfo;
    }   
}
